import { combineReducers } from 'redux'
import appointmentReducer from './appointmentReducer.js'
import stylistReducer from './stylistReducer.js'

const rootReducer = combineReducers({
  appointment: appointmentReducer,
  stylist: stylistReducer
});

export default rootReducer